import { useState } from 'react';
import type { FaqItem } from '@/mocks/gossip';

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-50">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : item.id)}
                className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-6 py-4 md:py-5 hover:bg-background-100 transition-colors cursor-pointer"
                aria-expanded={isOpen}
              >
                <span className="text-sm md:text-base text-foreground-900">{item.q}</span>
                <i
                  className={`shrink-0 text-lg text-primary-600 transition-transform ${
                    isOpen ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 md:px-6 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}